<template>
  <section>
    <div class="d-flex flex-row justify-space-between align-center mb-3">
      <h1 class="section-header__title">
        Контактные данные регионов
      </h1>
      <div class="d-flex flex-row align-start">
        <v-icon
          size="20"
          color="info"
          class="mt-2 mr-2"
        >
          mdi-magnify
        </v-icon>
        <v-text-field
          v-model="search"
          color="info"
          outlined
          label="Начните набирать наименование региона"
          class="search-field"
          dense
          style="min-width: 500px"
        />
      </div>
    </div>
    <wrapper-preview-category>
      <grid-table
        :headers="contactsData"
        :headers-for-rows="contactsData"
        :num-cols="contactsLength"
        :loading-data="loading"
        :data-rows="showingData"
        type-table="grid"
      >
        <template #numbers="{row}">
          <template v-if="row.contact.length > 0">
            <span class="d-flex flex-row align-center">
              <v-icon
                size="15"
                class="mr-2"
                color="info">
              mdi-phone
            </v-icon>
              {{
                row.contact[0].workPhoneExtension ? `${row.contact[0].workPhoneNumber} (${row.contact[0].workPhoneExtension})` : row.contact[0].workPhoneNumber
              }}
            </span>
            <span class="d-flex flex-row align-center">
              <v-icon
                size="15"
                class="mr-2"
                color="info">
                mdi-cellphone
              </v-icon>
                {{
                row.contact[0].personalPhoneExtension ? `${row.contact[0].personalPhoneNumber} (${row.contact[0].personalPhoneExtension})` : row.contact[0].personalPhoneNumber
              }}
            </span>
            <span class="d-flex flex-row align-center mt-3" v-if="row.contact.length > 1">
              <v-icon
                size="15"
                class="mr-2"
                color="info">
              mdi-phone
            </v-icon>
              {{
                row.contact[1].workPhoneExtension ? `${row.contact[1].workPhoneNumber} (${row.contact[1].workPhoneExtension})` : row.contact[1].workPhoneNumber
              }}
            </span>
            <span class="d-flex flex-row align-center" v-if="row.contact.length > 1">
              <v-icon
                size="15"
                class="mr-2"
                color="info">
                mdi-cellphone
              </v-icon>
                {{
                row.contact[1].personalPhoneExtension ? `${row.contact[1].personalPhoneNumber} (${row.contact[1].personalPhoneExtension})` : row.contact[1].personalPhoneNumber
              }}
            </span>
          </template>
        </template>
        <template #email="{row}">
          <template v-if="row.contact.length > 0">
            <div class="d-flex align-center main-color ">
              <v-icon size="15" class="mr-2" color="info">mdi-mail</v-icon>
              <span class="text-decoration-underline">{{ row.contact[0].email }}</span>
            </div>
            <div class="d-flex align-center main-color mt-3" v-if="row.contact.length > 1">
              <v-icon size="15" class="mr-2" color="info">mdi-mail</v-icon>
              <span class="text-decoration-underline">{{ row.contact[1].email }}</span>
            </div>
          </template>
        </template>
        <template #filesDto="{row}">
          <template v-if="row.contact.length > 0">
            <div class="d-flex flex-column" v-for="file in filesConfig(row)" :key="file.id">
              <strong>{{ file.name }}</strong>
              <div class="d-flex main-color">
                <img src="@/assets/icons/file-outline.svg" alt=""/>
                <span @click="downloadFile(file.fileDto)" class="file-link mr-4">
                <v-progress-circular
                  v-if="downloadingFileToServer.regionId === file.id && downloadingFileToServer.value && downloadingFileToServer.fileType === file.fileType"
                  indeterminate color="primary" size="14" width="2"/>
                {{ file.fileDto.fileNameOrig }}
              </span>
              </div>
            </div>
          </template>
        </template>
      </grid-table>
    </wrapper-preview-category>
  </section>
</template>

<script>
import WrapperPreviewCategory from "@/components/wrappers/WrapperPreviewCategory";
import contactsRegions from "@/helpers/tableConfigs/contactsRegions";
import GridTable from "@/components/GridTable/GridTable";
import {mapActions, mapGetters} from "vuex";
import {saveFile} from "@/utils/saveFile";
import FilesController from "@/controllers/FilesController";
// import ContactsController from "@/controllers/ContactsController";

export default {
  name: "ContactsRegions",
  components: {GridTable, WrapperPreviewCategory},
  data() {
    return {
      search: '',
      headers: contactsRegions,
      loading: false,
      downloadingFileToServer: {regionId: 0, value: false, fileType: null},
      serverData: [],
    }
  },
  computed: {
    ...mapGetters('spr', {
      getRegions: 'getRegions',
      getRegionsStatus: 'getRegionsStatus'
    }),
    ...mapGetters('keycloak', {isAdmin: 'isAdmin', isCO: 'isCO'}),
    showingData() {
      const array = this.getRegions.filter(el => ![94, 95, 96, 97, 1001, 1002, 1003].includes(el.id) && el.district.id !== 999);
      return array.filter(el => !this.search || el.name.toLowerCase().search(this.search.toLowerCase()) !== -1)
    },
    contactsData() {
      const array = this.headers.massive;
      if (!this.isAdmin) {
        array.pop()
      }
      return array
    },
    contactsLength() {
      let num = this.headers.countCells;
      if (!this.isAdmin) {
        num--
      }
      return num
    }
  },

  // created() {
  //   this.getServerData();
  // },

  methods: {
    ...mapActions('spr', {getRegionsFromServer: 'getRegionsFromServer'}),
    filesConfig(region) {
      const files = region.contact[0].filesDto;
      const confirmFile = {
        name: 'Файл подтверждения введенных данных',
        types: ['application/pdf'],
        typesForChose: ['application/pdf'],
        id: 0,
        fileDto: files.filter(f => f.fileType === 'CONFIRMED_FILE_STAGE_TWO')?.pop(),
        fileType: 'CONFIRMED_FILE_STAGE_TWO'
      }
      const calcFile = {
        name: 'Расчетный файл',
        types: ['application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'],
        typesForChose: ['.xlsx', '.xls'],
        id: 1,
        fileDto: files.filter(f => f.fileType === 'CALCULATED_FILE_STAGE_TWO')?.pop(),
        fileType: 'CALCULATED_FILE_STAGE_TWO'
      }
      const explainFile = {
        name: 'Пояснительная записка',
        types: ['application/pdf'],
        typesForChose: ['application/pdf'],
        id: 2,
        fileDto: files.filter(f => f.fileType === 'EXPLANATORY_FILE_STAGE_TWO')?.pop(),
        fileType: 'EXPLANATORY_FILE_STAGE_TWO'
      }
      const agreementFile = [5, 6, 11, 17, 18, 28, 30, 33, 36, 42, 47, 56, 65, 66, 81, 89, 90, 93].includes(region.id) ? {
        name: 'Согласование проекта КЦП с Министерством Российской Федерации по развитию Дальнего Востока и Арктики',
        types: ['application/pdf'],
        typesForChose: ['application/pdf'],
        id: 3,
        fileDto: files.filter(f => f.fileType === 'AGREEMENT_FILE_STAGE_TWO_VOSTOK')?.pop(),
        fileType: 'AGREEMENT_FILE_STAGE_TWO_VOSTOK'
      } : null;
      const agreementFile2 = [16, 20, 24, 29, 69, 71, 85].includes(region.id) ? {
        name: 'Согласование проекта КЦП с Министерством экономического развития Российской Федерации',
        types: ['application/pdf'],
        typesForChose: ['application/pdf'],
        id: 4,
        fileDto: files.filter(f => f.fileType === 'AGREEMENT_FILE_STAGE_TWO_ECONOM')?.pop(),
        fileType: 'AGREEMENT_FILE_STAGE_TWO_ECONOM'
      } : null;
      const result = [confirmFile, calcFile, explainFile];
      if (agreementFile)
        result.push(agreementFile)
      if (agreementFile2)
        result.push(agreementFile2)

      return result.filter(el => el.fileDto !== null && el.fileDto !== undefined)
    },

    // async getServerData() {
    //   try {
    //     this.loading = true;
    //     // await this.getRegionsFromServerWithFiles();
    //     console.log('1');
    //     this.loading = false;
    //   } catch (e) {
    //     console.log('2');
    //     this.loading = false;
    //   }
    // },

    async downloadFile(event) {
      this.downloadingFileToServer.regionId = event.userId;
      this.downloadingFileToServer.value = true;
      this.downloadingFileToServer.fileType = event.fileType;
      try {
        const response = await FilesController.getFile(event.id)
        this.downloadingFileToServer.regionId = 0;
        this.downloadingFileToServer.value = false;
        this.downloadingFileToServer.fileType = event.fileType;
        saveFile({...response, fileBytes: response.file}, false);
      } catch (e) {
        this.downloadingFileToServer.regionId = 0;
        this.downloadingFileToServer.value = false;
        this.downloadingFileToServer.fileType = event.fileType;
        console.log("e", e)
      }
    },
  },
}
</script>

<style scoped>

</style>